<template>
    <header :class="[
        'header',
        { 'header--menu-opened': isMenuOpened }
    ]">
        <div class="container">
            <div class="header__container">
                <div class="header__logo">
                    <z-logo
                        site-dir="/"
                        :is-index="isIndex" />
                </div>
                <div class="u-entire-width">
                    <div class="header__top-menu">
                        <navigation-top />
                        <site-selector />
                        <fast-search />
                        <div class="hide-me--default show-me--tablet">
                            <navigation-mobile v-if="isSmallDevice" @menuToggle="handleMenuToggle" />
                        </div>
                    </div>
                    <navigation-main v-if="!isSmallDevice" class="hide-me--tablet" @menuToggle="handleMenuToggle" />
                </div>
            </div>
        </div>
    </header>
</template>

<script setup>
import NavigationMain from '@/components/NavigationMain'
import NavigationTop from '@/components/NavigationTop'
import NavigationMobile from '@/components/NavigationMobile'
import SiteSelector from '@/components/SiteSelector'
import FastSearch from '@/components/FastSearch'
import { computed, ref, watch } from 'vue'
import { useGetter } from '@/composable/useGetter'

const { device, burgerMenu } = useGetter(['device', 'burgerMenu'])
const isMenuOpened = ref(false)
const isSmallDevice = ref(false)

const isIndex = computed(() => {
    return ['/ru/', '/en/', '/'].includes(window.location.pathname)
})

const handleMenuToggle = (value) => {
    isMenuOpened.value = value
}

watch(device, (newVal) => {
    isSmallDevice.value = ['tablet', 'v-tablet', 'mobile'].includes(newVal)

    if (isSmallDevice.value && burgerMenu) return
    else if (isSmallDevice.value && isMenuOpened.value) {
        handleMenuToggle(false)
    }
})
</script>

<style lang="scss">
.header {
    display: flex;
    align-items: center;
    @include padding-level(top, S);
    @include padding-level(bottom, L);
    position: relative;
    z-index: 5;
    background: linear-gradient(
        180deg,
        #026958 39.22%,
        rgba(2, 105, 88, 0.99) 43.27%,
        rgba(2, 105, 88, 0.96) 47.32%,
        rgba(2, 105, 88, 0.92) 51.37%,
        rgba(2, 105, 88, 0.85) 55.42%,
        rgba(2, 105, 88, 0.77) 59.48%,
        rgba(2, 105, 88, 0.67) 63.53%,
        rgba(2, 105, 88, 0.56) 67.58%,
        rgba(2, 105, 88, 0.44) 71.63%,
        rgba(2, 105, 88, 0.33) 75.69%,
        rgba(2, 105, 88, 0.23) 79.74%,
        rgba(2, 105, 88, 0.15) 83.79%,
        rgba(2, 105, 88, 0.08) 87.84%,
        rgba(2, 105, 88, 0.04) 91.9%,
        rgba(2, 105, 88, 0.01) 95.95%,
        rgba(2, 105, 88, 0) 100%
    );

    @include breakpoint(tablet) {
        @include padding-level(bottom, L);
        @include padding-level(top, M);
    }

    @include breakpoint(v-tablet) {
        min-height: 129px;
        @include padding-level(bottom, S);
        @include padding-level(top, S);
    }

    @include breakpoint(mobile) {
        min-height: 87px;
        @include padding-level(bottom, 2XS);
        @include padding-level(top, 2XS);
    }

    &::before {
        content: '';
        width: 100%;
        height: 105%;
        background: var(--color-primary);
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        z-index: -1;
    }

    &--menu-opened {
        &::before {
            opacity: 1;
        }
    }

    &__container {
        display: flex;
        align-items: center;
        width: 100%;
        @include gap-level(4XL);

        @include breakpoint(laptop) {
            @include gap-level(3XL);
        }
        @include breakpoint(mobile) {
            @include gap-level(L);
        }
    }

    &__logo {
        position: relative;
        height: fit-content;
        width: 13vw;
        min-width: 120px;
        z-index: 11;

        @include breakpoint(tablet) {
            width: 15vw;
            min-width: 62px;
        }

        @include breakpoint(v-tablet) {
            width: 18vw;
        }

        @include breakpoint(mobile) {
            min-width: 48px;
            width: 30vw;
        }
    }

    &__top-menu {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @include margin-level(bottom, XS);
        max-height: 40px;
        margin-left: auto;
        gap: 16px;

        @include breakpoint(tablet) {
            margin-bottom: 0;
            @include gap-level(M);
        }

        @include breakpoint(mobile) {
            @include gap-level(2XS);
        }

        .navigation-top {
            @include margin-level(right, XS);
            z-index: 2;

            @include breakpoint(tablet) {
                display: none;
            }
        }
    }
    .site-selector {
        position: relative;
        height: 100%;
        z-index: 11;
    }
}
body.header-absolute{
    .header{
        position: absolute;
        width: 100%;
    }
}
</style>
